import { render, staticRenderFns } from "./OCContentBox.html?vue&type=template&id=15ae1b76&scoped=true&"
import script from "./OCContentBox.ts?vue&type=script&lang=ts&"
export * from "./OCContentBox.ts?vue&type=script&lang=ts&"
import style0 from "./OCContentBox.css?vue&type=style&index=0&id=15ae1b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ae1b76",
  null
  
)

export default component.exports